{
    "cookie_consent_title": "Ønsker du å sjå dette innhaldet?",
    "cookie_consent_button": "Opne innstillingar",
    "cookie_consent_description": {
        "type": "markdown",
        "value": "For å spele av denne videoen, treng vi samtykket ditt."
    },
    "playVideo": "Spel av video",
    "hearVisualInterpretation": "Høyr synstolking av videoen.",
    "doneVisualInterpretation": "Synstolking av video er ferdig lest opp."
}
